module.exports = __webpack_public_path__ + "media/images/front/common/icon_login-4e4ec4edb5ff1f8ceca74fad943e6d50.svg";